module.exports = __webpack_public_path__ + "static/media/feedbackReceived_animation.ba61f0a7.gif";